import { Heading } from '@spark-web/heading';
import { CurrencyDollarIcon, ShieldCheckIcon, UserGroupIcon } from '@spark-web/icon';
import { Inline } from '@spark-web/inline';
import { ContentDialog } from '@spark-web/modal-dialog';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

import { Button as BrighteButton } from '~/components/common/button';
import { Footer } from '~/components/footer';
import { AnalyticsEvents } from '~/constants/analytics';
import { useModal } from '~/hooks/useModal';
import { useAnalyticsContext } from '~/provider/AnalyticsProvider';

export const LandingInformation = () => {
  const { close, onCloseAutoFocus, isOpen } = useModal('landing-information');
  const { track } = useAnalyticsContext();

  const onGetStartedClick = () => {
    close();
    track(AnalyticsEvents.LandingGetStartedClicked);
  };

  return (
    <ContentDialog
      title="Brighte Marketplace"
      showCloseButton
      isOpen={isOpen}
      onToggle={close}
      onCloseAutoFocus={onCloseAutoFocus}
    >
      <Stack gap="xxlarge">
        <Heading level="2">{"Compare up to 3 vendors and we'll help you pick the best fit"}</Heading>
        <Stack gap="xlarge">
          <Inline alignY="center" gap="small">
            <UserGroupIcon />
            <Text>Vendors will contact you by phone</Text>
          </Inline>
          <Inline alignY="center" gap="small">
            <CurrencyDollarIcon />
            <Text>Quotes arrive within 1-2 business days</Text>
          </Inline>
          <Inline alignY="center" gap="small">
            <ShieldCheckIcon />
            <Text>{"You're not locked in—compare and decide"}</Text>
          </Inline>
          <BrighteButton rounded type="button" onClick={onGetStartedClick}>
            Get started
          </BrighteButton>
          <Footer />
        </Stack>
      </Stack>
    </ContentDialog>
  );
};
